import styled from '@emotion/styled'

export const FlexColumn = styled.div<{
  flex?: string
  gap?: number
  justify?:
    | 'start'
    | 'end'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'stretch'
    | 'inherit'
    | 'initial'
}>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: stretch;
  gap: ${(props) => props.gap || 0}px;
  flex: ${(props) => props.flex || 'auto'};
  justify-content: ${(props) => props.justify || 'start'};
`

export const FlexRow = styled.div<{
  flex?: string
  gap?: number
  align?: 'start' | 'end' | 'center' | 'flex-start' | 'flex-end' | 'baseline' | 'stretch' | 'inherit' | 'initial'
  justify?:
    | 'start'
    | 'end'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'stretch'
    | 'inherit'
    | 'initial'
  wrap?: 'wrap' | 'nowrap' | 'wrap-reverse'
}>`
  flex: ${(props) => props.flex || '0 0 auto'};
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: ${(props) => props.align || 'stretch'};
  justify-content: ${(props) => props.justify || 'start'};
  gap: ${(props) => props.gap || 0}px;
  flex-wrap: ${(props) => props.wrap || 'nowrap'};
`

export const GrowingFlexRow = styled(FlexRow)`
  flex-grow: 1;
`

export type FlexProps = {
  col?: boolean
  center?: boolean
  align?: 'start' | 'end' | 'center' | 'flex-start' | 'flex-end' | 'baseline' | 'stretch' | 'inherit' | 'initial'
  gap?: number
  flex?: string
}

export const Flex = styled.div<FlexProps>`
  display: flex;
  flex-direction: ${(props) => (props.col ? 'column' : 'row')};
  ${(props) => props.center && 'justify-content: center;'}
  ${(props) => props.flex && `flex: ${props.flex || '1 1 auto'};`}
  ${(props) => props.align && `align-items: ${props.align}`};
  ${(props) => props.gap && `gap: ${props.gap}px`};
`

export const Seperator = styled.div<{ width?: number; height?: number }>`
  height: ${(props) => props.height || 0}px;
  width: ${(props) => props.width || 0}px;
`
